import React, { useRef, useState } from 'react';

import { useQuery } from 'react-query';
import { fetchTransferList } from 'api/washhub';

import { useWashHubListener } from 'hooks';
import { useToast } from '@chakra-ui/react';
import { selectors } from 'store/slices/washhub';
import { washHub } from 'store/slices';
import { TransfersProps } from './Transfers.props';

import TransfersView from './Transfers.view';

const TransfersContainer = (props: TransfersProps) => {
  const [page, setPage] = useState(1);
  const [endDate, setEndDate] = useState<Date>();
  const [startDate, setStartDate] = useState<Date>();

  const shouldDelayRef = useRef(false);

  const toast = useToast();

  const washHubId = selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const queryKey = ['fetch-transfers', page, washHubId, endDate, startDate];
  const queryFn = async () => {
    if (shouldDelayRef.current) {
      await new Promise((res) => setTimeout(res, 3000));

      shouldDelayRef.current = false;
    }

    const response = await fetchTransferList({
      page,
      limit: 10,
      washHub: washHubId,
      endDate,
      startDate,
    });

    return response;
  };

  const options = {
    enabled: isWashHubIdValid,
    onSuccess: () => {
      toast({
        status: 'success',
        description: 'transfers list updated',
        isClosable: true,
        duration: 2000,
        position: 'bottom-right',
      });
    },
  };

  const { data = [], isFetching, refetch } = useQuery(
    queryKey,
    queryFn,
    options,
  );

  useWashHubListener(() => {
    setPage(1);
    setStartDate(undefined);
    setEndDate(undefined);
  });

  const onSearchPress = (startDate: Date | null, endDate: Date | null) => {
    if (startDate) {
      setStartDate(startDate);
    }

    if (endDate) {
      setEndDate(endDate);
    }
  };

  const onSearchClear = () => {
    setStartDate(undefined);
    setEndDate(undefined);
  };

  const addDelayOnClose = () => {
    shouldDelayRef.current = true;
  };

  return (
    <TransfersView
      data={data}
      handleRefetch={refetch}
      isFetching={isFetching}
      onSearchClear={onSearchClear}
      onSearchPress={onSearchPress}
      addDelayOnClose={addDelayOnClose}
    />
  );
};

export default TransfersContainer;
